import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Early capture of beforeinstallprompt event (before React renders)
// This ensures the prompt is available even if user navigates to Settings quickly
window.pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.pwaInstallPrompt = e;
  console.log('PWA install prompt captured early');
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker Registration:
// - firebase-messaging-sw.js is registered in firebase.js for push notifications
// - We DON'T register service-worker.js separately to avoid conflicts
// - firebase-messaging-sw.js handles both PWA caching and push notifications
console.log('PWA: Service worker registration handled by firebase.js');
